import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


class Signatories {
  email_person: string = '';
  defined_signature_methods: string[] = [];
  name: string = '';
  tax_id: string = '';
}


@Component({
  selector: 'app-signature-modal',
  templateUrl: './signature-modal.component.html',
  styleUrls: ['./signature-modal.component.css']
})
export class SignatureModalComponent implements OnInit {
  signatories: Signatories = new Signatories();

  // use true to use on production
  demoData: boolean = false;

  @Input() my_modal_title:string = "Firma de documentos";
  @Input() my_modal_content:string = "Firmante";

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.demoData) {
      this.signatories.email_person='juanmanuelriverom+mifiel1@gmail.com';
      this.signatories.name='Contacto Tracer';
      this.signatories.tax_id='AAA010101AAA'
    }
  }

  closeModalWithResult() {
    // Pass data back to the parent component
    this.activeModal.close(this.signatories);
  }

  closeModalWithoutResult() {
    // Dismiss the modal without passing data
    this.activeModal.dismiss('Dismissed without result');
  }

  private isValidEmail(email: string): boolean {
    // Add your custom email validation logic here
    // You might want to use a regular expression or another validation method
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

}
